export default {
  title: "Galerie",
  noImages: "Aucune image n'a encore été publiée.",
  loadImageFailedErrorMessage: "Une erreur s'est produite et l'image n'a pas pu être chargée. Veuillez réessayer."
}
